import { sanitizeUrl } from "@/lib/helpers";

/** Artist profiles may contain a legacy `//ui_v2/...` pseudo-URL. Unlike a
 * protocol-relative CDN URL it has no domain, and passing it to next/image
 * throws during render. Show the avatar initial instead of breaking the page. */
export function profileImageUrl(value?: string | null): string {
  const raw = value?.trim() ?? "";
  if (raw.startsWith("//") && !raw.slice(2).split("/")[0].includes(".")) return "";
  return sanitizeUrl(raw);
}

/**
 * The banner the backend gives every new account (`…/profile/495005/-495005.jpg`, a plain light-blue
 * picture). It is nobody's own banner, so it is read as none and the page draws its own art in its place.
 */
const DEFAULT_BANNER = /\/profile\/495005\/-495005\.jpg(?:$|[?#])/i;

export function profileBannerUrl(value?: string | null): string {
  const url = profileImageUrl(value);
  return url && DEFAULT_BANNER.test(url) ? "" : url;
}
